/**
 * 개인사업자 경정청구 ID를 기반으로 콘솔 URL을 생성
 *  refundId가 '연도-tin' 값으로 만들어져 있어 tin을 분리 후, base64로 변환하여 사용
 */
export function getConsoleURLIndividual(refundId: string) {
  const base64Tin = btoa(refundId.slice(5));

  return `https://works.brics.zent.kr/refund/${base64Tin}`;
}

/**
 * 법인사업자 경정청구 ID를 기반으로 콘솔 URL을 생성
 *   refundId가 '연도-tin' 값으로 만들어져 있어 tin을 분리 후, 사용
 */
export function getConsoleURLCorporation(refundId: string) {
  const tin = refundId.slice(5);

  return `https://works.brics.zent.kr/corptax/${tin}`;
}
